/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 24th 2023, 5:17:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { CSSEditor, WYSIWYG, WYSIWYGProps, AlertSnackBar } from "ui-widgets";

interface HTMLEditorProps extends Pick<WYSIWYGProps, "appendContents" | "defaultValue" | "setContents" | "minHeight"> {
  onChangeHTMLContent: (content: string) => void;
  onChangeLayoutCSS: (css: string) => void;
  css: string;
  cssErrorMessage?: string;
}

export const HTMLEditor = ({
  css,
  onChangeHTMLContent,
  setContents,
  appendContents,
  defaultValue,
  minHeight,
  cssErrorMessage,
  onChangeLayoutCSS,
}: HTMLEditorProps) => {
  return (
    <Stack direction="row" spacing={1}>
      <div dangerouslySetInnerHTML={{ __html: `<style>${css}</style>` }} />
      <WYSIWYG
        defaultValue={defaultValue}
        appendContents={appendContents}
        setContents={setContents}
        onChange={onChangeHTMLContent}
        minHeight={minHeight ?? "300px"}
      />
      {cssErrorMessage && (
        <AlertSnackBar
          severity="error"
          open={Boolean(cssErrorMessage)}
          message={cssErrorMessage}
          handleClose={() => {}}
        />
      )}
      <CSSEditor defaultValue={css} onChangeLayoutCSS={onChangeLayoutCSS} />
    </Stack>
  );
};
